import * as z from "zod";

export const disconnectRichpanelIntegration = {
  name: "disconnectRichpanelIntegration" as const,
  input: z.null(),
  output: z.object({ success: z.boolean() }),
};
